const PREFIX = "vinci:form:";

export function readSessionValue<T>(key: string, fallback: T): T {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    return raw !== null ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeSessionValue<T>(key: string, value: T): void {
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // sessionStorage indisponível (modo privado/quota) — progresso simplesmente não persiste
  }
}

export function clearSessionValues(keys: string[]): void {
  for (const key of keys) {
    try {
      sessionStorage.removeItem(PREFIX + key);
    } catch {
      // ignore
    }
  }
}
